<template>
  <button class="saved-filters-counter" @click="$emit('click', $event)">
    <BasicSection appearance="horizontal">
      <div class="saved-filters-counter__wrapper">
        <span class="saved-filters-counter__title">
          Сохранённые фильтры
        </span>
        <span class="saved-filters-counter__count" v-text="savedFilters.items.length" />
      </div>
    </BasicSection>
  </button>
</template>

<script>
  import BasicSection from "src/components/sections/BasicSection/BasicSection.vue";
  export default {
    name: 'SavedFiltersCounter',
    components: { BasicSection },
    inject: ['savedFilters'],
  }
</script>